import Navbar from "../components/Navbar";
import Header from "../components/Header";
import MeetNewCar from "../components/MeetNewCar";
import Discover from "../components/Discover";



const HomePage = () => {
    return (
        <div>
            
           
            <Header/>
            <MeetNewCar/>
        </div>
    );
}

export default HomePage;
